import { all } from '@redux-saga/core/effects';
export const allSagas = function* () {
	yield all([
	]);
};
